import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontWeights, FormInput } from '@calm-web/design-system';

export const Wrapper = styled.form`
	padding: 20px 0;
`;

export const TextWrapper = styled.div`
	margin: 0.75rem 0;
	text-align: center;
`;

export const ExpressCheckoutWrapper = styled.div`
	margin: 0.75rem 0;
`;

// Same vertical rhythm as the card block above it, so the row doesn't touch the purchase terms or
// submit button below.
export const TruemedWrapper = styled.div`
	margin: 0.75rem 0;
`;

export const NoticeWrapper = styled.div`
	margin-top: 1rem;
`;

export const NameOnCardInput = styled(FormInput)`
	margin-bottom: 0.75rem;

	& label {
		color: ${palette('gray5')};
		font-size: 1rem;
		font-weight: ${FontWeights.Medium};
	}

	& input {
		border: 2px ${palette('gray2')} solid;
		border-width: 2px !important;
		border-radius: 6px;
		color: ${palette('gray5')};
		font-size: 1rem;
		font-weight: ${FontWeights.Medium};
		height: 66px;
	}
`;

// The custom postal input (Clover gap-fill for CA/UK/PR). Reuses the name field's
// styling so it matches the form's other inputs / the adjacent Stripe fields (2px
// gray border, 6px radius, gray5 label), and adds a top margin so it sits evenly
// below the Payment Element's mandate text rather than flush against it.
export const PostalCodeInput = styled(NameOnCardInput)`
	margin-top: 0.75rem;
`;
